import React, { Component } from 'react'

import { i18n } from '~/i18n'

import ContentBlock from '../content-block'
import Modal from '../modal'

export type Props = {
  expired: boolean
}
type State = {
  showExpired: boolean
}

export default class Expiration extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showExpired: this.props.expired,
    }
  }

  showExpiredToggle() {
    this.setState({
      showExpired: !this.state.showExpired,
    })
  }

  render() {
    if (!this.state.showExpired) return null
    return (
      <Modal
        onClose={this.showExpiredToggle.bind(this)}
        title={i18n.t('components.expiration.title')}
        actions={{
          primary: {
            onClick: this.showExpiredToggle.bind(this),
            className: 'button-confirm',
            text: i18n.t('components.expiration.close_btn'),
            type: 'primary',
          },
        }}
        size="small"
      >
        <ContentBlock>{i18n.t('components.expiration.content')}</ContentBlock>
      </Modal>
    )
  }
}
